import { render } from "./ModalCompare.vue?vue&type=template&id=93617f62"
import script from "./ModalCompare.vue?vue&type=script&lang=js"
export * from "./ModalCompare.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__